import { ChainId } from '@jessupwall02/sdk'
import MULTICALL_ABI from './abi.json'

const MULTICALL_NETWORKS: { [chainId in ChainId]: string } = {
  [ChainId.MAINNET]: '0xaEC500735a61DD71A3cc50F8F51082408a930789',
  [ChainId.BSCTEST]: '0x1dbc13D344C38479B60f2Ea60d990484BCe95c15'
}

export { MULTICALL_ABI, MULTICALL_NETWORKS }
